// travel-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'trv.privateRefundSuffix': 'se incluye en el siguiente pago de nómina sin aumentar el salario sujeto a impuestos, las vacaciones pagadas, la cotización del empleador ni la OTP.',
  'trv.rejectReasonRequired': 'Introduce un breve motivo del rechazo.',
  'trv.showApproved': 'Mostrar aprobados',
  'trv.tripCounts': '{mileage} trayectos · {stays} pernoctaciones · {expenses} gastos',
  'trv.expenseSaved': 'Gasto guardado.',
  'trv.expenseSaveFailed': 'No se pudo guardar el gasto.',
  'trv.voucherFetchFailed': 'No se pudo obtener el justificante.',
  'trv.voucherNoViewLink': 'No se encontró ningún enlace de visualización del justificante.',
  'trv.viewVoucher': 'Ver justificante',
  'trv.travelSaveFailed': 'No se pudo guardar el viaje.',
  'trv.statusUpdateFailed': 'No se pudo actualizar el estado del viaje.',
  'trv.deleteConfirm': '¿Eliminar la nota de gastos de viaje "{purpose}"?',
  'trv.travelDeleted': 'Viaje eliminado.',
  'trv.travelDeleteFailed': 'No se pudo eliminar el viaje.',
  'trv.travelCopied': 'Viaje copiado a un nuevo borrador.',
  'trv.travelCopyFailed': 'No se pudo copiar el viaje.',
  'trv.viewDetails': 'Ver detalles',
  'trv.editLine': 'Editar la línea',
  'trv.editedAfterSubmit': 'Modificado tras el envío',
  'trv.tollAmount': 'peaje {amount}',
  'trv.deleteTrip': 'Eliminar el trayecto',
  'trv.deleteStay': 'Eliminar la pernoctación',
  'trv.attachmentMark': '● Adjunto',
  'trv.deleteExpense': 'Eliminar el gasto',
  'trv.history': 'Historial',
  'trv.historyHelp': 'Quién ha modificado la nota de gastos de viaje y cuándo.',
  'trv.companyPaidDirect': '{amount} pagado con tarjeta de empresa/cuenta corriente se contabiliza directamente y no forma parte del pago de nómina.',
  'trv.pickEmployee': 'Selecciona un empleado.',
  'trv.purposeRequired': 'Indica la finalidad del viaje.',
  'trv.travelSaved': 'Viaje guardado.',
  'trv.calculateSubsistence': 'Calcular dietas',
  'trv.addStop': '+ Añadir parada',
  'trv.addPassenger': '+ Añadir pasajero',
  'trv.addTrailerKm': '+ Conducido con remolque',
  'trv.addForestRoadKm': '+ Conducido por camino forestal y de obra',
  'trv.pickDateAndStayType': 'Selecciona la fecha y el tipo de estancia.',
  'trv.lodgingDescriptionRequired': 'Introduce una descripción del lugar de alojamiento.',
  'trv.stayTypeHint': 'Elige otro alojamiento si, por ejemplo, te alojaste en un apartamento o una habitación de alquiler (normalmente Airbnb o similar).',
  'trv.otherStayHintLead': 'Úsalo solo si no era posible cocinar en el alojamiento. Si te alojaste en casa de alguien o si el alojamiento tenía, por ejemplo, una placa de cocina, debes elegir',
  'trv.lodgingHint': 'Obligatorio. Introduce el nombre y la dirección del lugar de alojamiento.',
  'trv.mealsHint': 'Marca las comidas que pagaste tú mismo. Si el desayuno estaba incluido en el alojamiento, no lo marques aquí.',
  'trv.calculatedSubsistence': 'Dieta calculada ({rate} kr/día · tarifa estatal)',
  'trv.expenseRequirements': 'Se requieren una descripción, un importe y al menos un adjunto.',
});
